var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98301 17.9133H14.8655L14.298 16.0758C14.3822 16.1492 19.1663 20.25 19.1663 20.25V2.3125C19.1097 1.1975 18.1497 0.25 16.9597 0.25L2.98717 0.2525C1.79801 0.2525 0.833008 1.20167 0.833008 2.31667V15.85C0.833008 17.0258 1.79634 17.9133 2.98301 17.9133ZM11.773 4.98583L11.7455 4.99583L11.7555 4.98583H11.773ZM5.41384 6.04333C6.94134 4.93167 8.35717 4.985 8.35717 4.985L8.47134 5.0975C6.60217 5.54333 5.75467 6.37833 5.75467 6.37833C5.84134 6.36 9.61551 4.1825 14.1888 6.43333C14.1888 6.43333 13.3397 5.6525 11.5855 5.1525L11.7405 5C11.983 5.00083 13.2663 5.04583 14.6397 6.05C14.6397 6.05 16.1763 8.675 16.1763 11.9C16.1255 11.8383 15.223 13.2883 12.9005 13.3383C12.9005 13.3383 12.5072 12.8933 12.2272 12.505C13.5855 12.115 14.0938 11.335 14.0938 11.335C11.4497 13 9.13217 12.74 6.35967 11.615C6.33384 11.615 6.32217 11.6033 6.30884 11.59V11.585C6.29551 11.5725 6.28384 11.56 6.25801 11.56H6.20801C6.03801 11.4483 5.92467 11.3933 5.92467 11.3933C5.92467 11.3933 6.43217 12.1733 7.73634 12.5633C7.39384 12.9542 7.05467 13.3983 7.05467 13.3983C4.73301 13.3433 3.88634 11.8933 3.88634 11.8933C3.88634 8.66333 5.41384 6.04333 5.41384 6.04333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9236 10.8925C12.5161 10.8925 12.9986 10.3925 12.9986 9.77583C12.9986 9.16333 12.5186 8.66333 11.9236 8.66333V8.66583C11.3336 8.66583 10.8503 9.16416 10.8486 9.78083C10.8486 10.3925 11.3311 10.8925 11.9236 10.8925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07402 10.8925C8.66652 10.8925 9.14902 10.3925 9.14902 9.77583C9.14902 9.16333 8.66985 8.66333 8.07735 8.66333L8.07402 8.66583C7.48152 8.66583 6.99902 9.16416 6.99902 9.78083C6.99902 10.3925 7.48152 10.8925 8.07402 10.8925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.e52f7b8c.svg";
export { ForwardRef as ReactComponent };